import React from 'react'
import { useDimensions } from 'src/ui/dimensions'

import { Intro as Desk } from './desk'
import { Intro as Mob } from './mob'

type Props = {
  images: TImages
  onScrollToForm: () => void
  onScrollToReward: () => void
}

export const Intro: React.FC<Props> = ({
  images,
  onScrollToForm,
  onScrollToReward,
}) => {
  const { isMobile } = useDimensions()
  const Component = isMobile ? Mob : Desk

  return (
    <Component
      images={images}
      onScrollToForm={onScrollToForm}
      onScrollToReward={onScrollToReward}
    />
  )
}
